import React from "react";
import {
  Box,
  Button,
  Divider,
  Inline,
  Stack,
  Text,
} from "@origin-digital/ods-core";

const ReadOnlyTextField = ({
  label,
  value,
  helperText = null,
  withAction = false,
  onAction,
  onCancel,
}: {
  label: string;
  value?: string;
  helperText?: string | React.ReactNode;
  withAction?: boolean;
  onAction?: () => void;
  onCancel?: () => void;
}) => {
  if (!value) {
    return null;
  }
  return (
    <Stack space="xsmall">
      <Box display="flex" alignItems="center">
        <Stack space="xxsmall">
          <Text variant="body-small" tone="neutralLight">
            {label}
          </Text>
          <Text>{value}</Text>
        </Stack>
        {withAction && (
          <Inline disableWrap={true} space="large">
            <Button
              variant="text"
              size="small"
              noTextPadding
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              variant="text"
              size="small"
              noTextPadding
              onClick={onAction}
            >
              Actioned
            </Button>
          </Inline>
        )}
      </Box>
      <Divider />
      {helperText ? helperText : null}
    </Stack>
  );
};

export default ReadOnlyTextField;
